"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inbox = exports.DeviceActions = exports.Masthead = exports.Navigate = void 0;
const EnumUtils_1 = require("../../utils/native/EnumUtils");
// =============================================================================
// Navigation
// =============================================================================
var Navigate;
(function (Navigate) {
    Navigate["DISMISS_WEBVIEW"] = "dismissWebview";
    Navigate["BACK_TO_HOME"] = "backToHome";
    Navigate["OPEN_WEBVIEW"] = "openWebview";
    Navigate["BACK"] = "back";
    Navigate["FORWARD"] = "forward";
    Navigate["DISABLE_WEBVIEW_CAN_GO_BACK"] = "disableWebviewCanGoBack";
    Navigate["RATING_STORE"] = "ratingStore";
    Navigate["USER_INBOX"] = "userInbox";
    Navigate["FILTERED_INBOX_NEIGHBOURHOOD_ISSUES"] = "filteredInboxNeighbourhoodIssues";
    Navigate["SERVICE_CATEGORY"] = "serviceCategory";
    Navigate["FAMILY_AND_PARENTING_CATEGORY"] = "familyAndParentingCategory";
    Navigate["SAVE_RECENT_ACCESS"] = "saveRecentAccess";
    Navigate["NAVIGATE_TO_ROUTE"] = "navigateToRoute";
})(Navigate || (exports.Navigate = Navigate = {}));
(function (Navigate) {
    Navigate.fn = {
        values: EnumUtils_1.EnumUtils.valuesFunc(Navigate),
        toEnumKey: EnumUtils_1.EnumUtils.toEnumKeyFunc(Navigate),
        toEnumValue: EnumUtils_1.EnumUtils.toEnumValueFunc(Navigate),
    };
})(Navigate || (exports.Navigate = Navigate = {}));
// =============================================================================
// Masthead
// =============================================================================
var Masthead;
(function (Masthead) {
    Masthead["HIDE"] = "hideMasthead";
    Masthead["SHOW"] = "showMasthead";
    Masthead["DISABLE_BACK_BUTTON"] = "disableBackButton";
    Masthead["ENABLE_BACK_BUTTON"] = "enableBackButton";
})(Masthead || (exports.Masthead = Masthead = {}));
(function (Masthead) {
    Masthead.fn = {
        values: EnumUtils_1.EnumUtils.valuesFunc(Masthead),
        toEnumKey: EnumUtils_1.EnumUtils.toEnumKeyFunc(Masthead),
        toEnumValue: EnumUtils_1.EnumUtils.toEnumValueFunc(Masthead),
    };
})(Masthead || (exports.Masthead = Masthead = {}));
// =============================================================================
// Device Actions
// =============================================================================
var DeviceActions;
(function (DeviceActions) {
    DeviceActions["GET_CURRENT_POSITION"] = "getCurrentPosition";
    DeviceActions["GET_CURRENT_POSITION_DISABLE_PROMPT"] = "getCurrentPositionDisablePrompt";
    DeviceActions["GET_CURRENT_POSITION_IGNORING_LOCATION_SETTING"] = "getCurrentPositionIgnoringLocationSetting";
    DeviceActions["TRIGGER_CAMERA_PERMISSION"] = "triggerCameraPermission";
    DeviceActions["GET_DEVICE_INFO"] = "getDeviceInfo";
    DeviceActions["DISABLE_SCROLLING_WEBVIEW"] = "disableScrollingWebview";
    DeviceActions["ENABLE_SCROLLING_WEBVIEW"] = "enableScrollingWebview";
})(DeviceActions || (exports.DeviceActions = DeviceActions = {}));
(function (DeviceActions) {
    DeviceActions.fn = {
        values: EnumUtils_1.EnumUtils.valuesFunc(DeviceActions),
        toEnumKey: EnumUtils_1.EnumUtils.toEnumKeyFunc(DeviceActions),
        toEnumValue: EnumUtils_1.EnumUtils.toEnumValueFunc(DeviceActions),
    };
})(DeviceActions || (exports.DeviceActions = DeviceActions = {}));
// =============================================================================
// INBOX
// =============================================================================
var Inbox;
(function (Inbox) {
    Inbox["REMOVE_RATING_PILL"] = "removeRatingPill";
})(Inbox || (exports.Inbox = Inbox = {}));
(function (Inbox) {
    Inbox.fn = {
        values: EnumUtils_1.EnumUtils.valuesFunc(Inbox),
        toEnumKey: EnumUtils_1.EnumUtils.toEnumKeyFunc(Inbox),
        toEnumValue: EnumUtils_1.EnumUtils.toEnumValueFunc(Inbox),
    };
})(Inbox || (exports.Inbox = Inbox = {}));
//# sourceMappingURL=enums.js.map